import { View } from "@gaming/srvg-classes-core";

export class PlaceholderView extends View {

    constructor( options ) {
        options = options || {};
        super( options );

        if (options.withSvgBackground === true){
            this.$domNode.html(
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 206 990" style="enable-background:new 0 0 206 990;" xml:space="preserve">' +
                '<style type="text/css"> .background{fill:url(#background-color);} .bars{fill:url(#bars-color);} </style> ' +
                '<g id="background">' +
                '<linearGradient id="background-color" gradientUnits="userSpaceOnUse" x1="103" y1="990" x2="103" y2="-9.094947e-13">'+
                '<stop  offset="0%" style="stop-color:var(--placeholder-background-color-1)"/>'+
                '<stop  offset="100%" style="stop-color:var(--placeholder-background-color-2)"/>'+
                '</linearGradient>'+
                '<rect id="background" class="background" width="206" height="990"/>'+
                '</g>'+
                '<g id="bars">'+
                '<linearGradient id="bars-color" gradientUnits="userSpaceOnUse" x1="103" y1="42.2502" x2="103" y2="990">'+
                '<stop  offset="0%" style="stop-color:var(--placeholder-bars-color-1);"/>'+
                '<stop  offset="100%" style="stop-color:var(--placeholder-bars-color-2)"/>'+
                '</linearGradient>'+
                '<path id="bars" class="bars" d="M206,159.2v20.2L0,62.4V42.3L206,159.2z M206,230.2v20.2L0,133.4v-20.2L206,230.2z M206,298.2v20.2L0,201.4v-20.2L206,298.2z M206,363.2v20.2L0,266.4v-20.2L206,363.2z M206,425.2v20.2L0,328.4v-20.2L206,425.2z M206,484.2v20.2L0,387.4v-20.2L206,484.2z M206,540.2v20.2L0,443.4v-20.2L206,540.2z M206,593.2v20.2L0,496.4v-20.2L206,593.2z M206,643.2v20.2L0,546.4v-20.2L206,643.2z M206,690.2v20.2L0,593.4v-20.2L206,690.2z M206,734.2v20.2L0,637.4v-20.2L206,734.2z M206,775.2v20.2L0,678.4v-20.2L206,775.2z M206,813.2v20.2L0,716.4v-20.2L206,813.2z M206,848.2v20.2L0,751.4v-20.2L206,848.2z M206,880.7v20.2L0,784v-20.2L206,880.7z M206,909.8V930L0,813v-20.2L206,909.8z M206,936.8V990H0V819.8L206,936.8z"/>'+
                '</g>'+
                '</svg>'
            );
        }
    }
}